import _ from 'lodash';
import { IUserJson } from '@scale/shared/types/user';
import { IProjectRole, RoleDescription } from '@scale/shared/corp/projectRoles';
import { IProjectJson } from '@scale/shared/types/project';

export function getUserName(user: IUserJson) {
  const userName = user.email.split('(')[0].trim();
  return _.startCase(userName.split('+')[0].replace('.', ' '));
}

function checkStartDate(role: IProjectRole, hasStarted: boolean) {
  if (hasStarted) {
    return new Date(role.startDate) < new Date();
  } else {
    return new Date(role.startDate) > new Date();
  }
}

function checkStopDate(role: IProjectRole, hasEnded: boolean) {
  if (hasEnded) {
    return role.stopDate && new Date(role?.stopDate) < new Date();
  } else {
    return !role.stopDate || new Date(role?.stopDate) > new Date();
  }
}

export const filterProjectNames = (
  projectRoles: IProjectRole[],
  hasStarted: boolean,
  hasEnded: boolean,
) => {
  return (
    projectRoles
      .filter(
        (r: IProjectRole) =>
          (r.project as IProjectJson).name &&
          checkStopDate(r, hasEnded) &&
          checkStartDate(r, hasStarted),
      )
      .map(function (r) {
        return (r.project as IProjectJson).name;
      })
      // gets unique project titles from all project roles
      .filter((project, idx, projects) => projects.indexOf(project) === idx)
  );
};

export const filterProjectRoles = (
  projectRoles: IProjectRole[],
  hasStarted: boolean,
  hasEnded: boolean,
) => {
  return (
    projectRoles!
      .filter(
        (r: IProjectRole) => r.role && checkStopDate(r, hasEnded) && checkStartDate(r, hasStarted),
      )
      .map((r: IProjectRole) => r.role && RoleDescription[r.role])
      // gets unique project titles from all project roles
      .filter((project, idx, projects) => projects.indexOf(project) === idx)
  );
};
